/**
 * 盘库计划状态（与 server/constants/inventoryCheckStatus.js 保持一致）
 */

export const INVENTORY_CHECK_STATUS = {
  PENDING: 1,
  IN_PROGRESS: 2,
  PENDING_DIFF_CONFIRM: 3,
  COMPLETED: 4,
  VOID: -1,
};

export const INVENTORY_CHECK_STATUS_LABEL = {
  [INVENTORY_CHECK_STATUS.PENDING]: "待盘库",
  [INVENTORY_CHECK_STATUS.IN_PROGRESS]: "盘库中",
  [INVENTORY_CHECK_STATUS.PENDING_DIFF_CONFIRM]: "待确认库存偏差",
  [INVENTORY_CHECK_STATUS.COMPLETED]: "已盘库",
  [INVENTORY_CHECK_STATUS.VOID]: "作废",
};

export const INVENTORY_CHECK_STATUS_TABS = [
  { name: String(INVENTORY_CHECK_STATUS.PENDING), code: INVENTORY_CHECK_STATUS.PENDING, label: "待盘库", showBadge: true },
  { name: String(INVENTORY_CHECK_STATUS.IN_PROGRESS), code: INVENTORY_CHECK_STATUS.IN_PROGRESS, label: "盘库中", showBadge: true },
  {
    name: String(INVENTORY_CHECK_STATUS.PENDING_DIFF_CONFIRM),
    code: INVENTORY_CHECK_STATUS.PENDING_DIFF_CONFIRM,
    label: "待确认库存偏差",
    showBadge: true,
  },
  { name: String(INVENTORY_CHECK_STATUS.COMPLETED), code: INVENTORY_CHECK_STATUS.COMPLETED, label: "已盘库", showBadge: false },
  { name: String(INVENTORY_CHECK_STATUS.VOID), code: INVENTORY_CHECK_STATUS.VOID, label: "作废", showBadge: false },
  { name: "all", code: "", label: "全部", showBadge: false },
];

export function getInventoryCheckStatusLabel(status) {
  if (status === "" || status === null || status === undefined) return "";
  const code = Number(status);
  return INVENTORY_CHECK_STATUS_LABEL[code] || "";
}

export function canStartInventoryCheck(status) {
  return Number(status) === INVENTORY_CHECK_STATUS.PENDING;
}

export function canViewInventoryCheckSnapshot(status) {
  const code = Number(status);
  return (
    code === INVENTORY_CHECK_STATUS.IN_PROGRESS ||
    code === INVENTORY_CHECK_STATUS.PENDING_DIFF_CONFIRM ||
    code === INVENTORY_CHECK_STATUS.COMPLETED
  );
}

export function canViewInventoryCheckAdjust(status) {
  return Number(status) === INVENTORY_CHECK_STATUS.COMPLETED;
}

export function canSubmitInventoryCheck(status) {
  return Number(status) === INVENTORY_CHECK_STATUS.IN_PROGRESS;
}

export function canConfirmInventoryCheckDiff(status) {
  return Number(status) === INVENTORY_CHECK_STATUS.PENDING_DIFF_CONFIRM;
}

export function canRejectInventoryCheckDiff(status) {
  return Number(status) === INVENTORY_CHECK_STATUS.PENDING_DIFF_CONFIRM;
}

export function canVoidInventoryCheck(status) {
  const code = Number(status);
  return code === INVENTORY_CHECK_STATUS.PENDING || code === INVENTORY_CHECK_STATUS.IN_PROGRESS;
}

export function canEditInventoryCheckRemark(status) {
  const code = Number(status);
  return (
    code === INVENTORY_CHECK_STATUS.PENDING ||
    code === INVENTORY_CHECK_STATUS.IN_PROGRESS ||
    code === INVENTORY_CHECK_STATUS.PENDING_DIFF_CONFIRM
  );
}
